
// 将下划线分割的对象属性转换为驼峰式aBcD属性
export function GetCamelObjectPro(obj) {
  const camelObj = {}
  Object.keys(obj).forEach(key => {
    const camelKey = key
      .replace(/_([a-zA-Z])/g, (match, offset) => offset.toUpperCase())
      .replace('_', '')
      .replace(/^[A-Z]/, s => s.toLowerCase())
    camelObj[camelKey] = obj[key]
  })
  return camelObj
}

export function IsNullOrEmpty(obj) {
  return obj === null || obj === undefined || obj === ''
}

export function OneOf(str, list) {
  if (Array.isArray(list)) {
    let hasStr = false
    for (let i = 0, len = list.length; i < len; i++) {
      if (list[i] === str) {
        hasStr = true
        break
      }
    }
    return hasStr
  } else {
    return false
  }
}

export function GetScrollTop() {
  let scrollTop = 0
  let bodyScrollTop = 0
  let documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTo
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}

export function GetScrollHeight() {
  let scrollHeight = 0
  let bodyScrollHeight = 0
  let documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}

export function GetWindowHeight() {
  let windowHeight = 0
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

// 日期格式化函数
export function DateFormat(date, fmt) {
  const target = date === '' ? new Date() : new Date(date)
  const o = {
    'M+': target.getMonth() + 1,
    'd+': target.getDate(),
    'h+': target.getHours(),
    'm+': target.getMinutes(),
    's+': target.getSeconds(),
    'q+': Math.floor((target.getMonth() + 3) / 3),
    'S': target.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (target.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt.indexOf('Na') !== -1 ? '' : fmt
}

// 深拷贝对象
export function DeepCopyObject(obj) {
  if (typeof obj === 'object') {
    return JSON.parse(JSON.stringify(obj))
  } else {
    console && console.log('传入非对象')
    return null
  }
}

// 数字金额大写转换(可以处理整数,小数,负数)
export function RmbToUpper(n) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  const head = n < 0 ? '欠' : ''
  n = Math.abs(n)

  let s = ''

  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }

  s = s || '整'
  n = Math.floor(n)

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}
